import { render, staticRenderFns } from "./attrs.vue?vue&type=template&id=44db4bee&scoped=true"
import script from "./attrs.vue?vue&type=script&lang=ts"
export * from "./attrs.vue?vue&type=script&lang=ts"
import style0 from "./attrs.vue?vue&type=style&index=0&id=44db4bee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db4bee",
  null
  
)

export default component.exports